export enum ModelId {
  GPT_5_2 = 'gpt-5.2',
  GPT_5_4_MINI = 'gpt-5.4-mini',
  GPT_5_4 = 'gpt-5.4',
  GPT_5_5 = 'gpt-5.5',
}

export enum LiteLLMModel {
  GPT_5_2 = 'openai/gpt-5.2',
  GPT_5_4_MINI = 'openai/gpt-5.4-mini',
  GPT_5_4 = 'openai/gpt-5.4',
  GPT_5_5 = 'openai/gpt-5.5',
}

export type ModelOption = {
  id: ModelId;
  label: string;
  description: string;
  litellmName: LiteLLMModel;
};

export const DEFAULT_MODEL: ModelOption = {
  id: ModelId.GPT_5_2,
  label: 'GPT-5.2',
  description: 'Default model',
  litellmName: LiteLLMModel.GPT_5_2,
};

export const DEV_MODELS: ModelOption[] = [
  {
    id: ModelId.GPT_5_4_MINI,
    label: 'GPT-5.4 Mini',
    description: 'Faster, lower cost',
    litellmName: LiteLLMModel.GPT_5_4_MINI,
  },
  {
    id: ModelId.GPT_5_4,
    label: 'GPT-5.4',
    description: 'Balanced performance',
    litellmName: LiteLLMModel.GPT_5_4,
  },
  {
    id: ModelId.GPT_5_5,
    label: 'GPT-5.5',
    description: 'Latest, most capable',
    litellmName: LiteLLMModel.GPT_5_5,
  },
];

export const ALL_MODELS: ModelOption[] = [DEFAULT_MODEL, ...DEV_MODELS];
